import React, { useState, useEffect } from "react";
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import "./TextEditor.css";
import "../Styles/SvgCommand.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function TextEditor(props) {
  const [isDragOver, setDragover] = useState(false);
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  const onDropDownItemClick = (itemSelected) => {};
  const shiftPosition = 1;
  useEffect(() => {
     props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    newStyle["position"] = "absolute";
   
    newStyle["border"] = undefined;
    return newStyle;
  };
  const onDropColumn = (e) => {
    e.stopPropagation();
    props.onDropColumn(e, props.data);
    setDragover(false);
  };
  const onDrag = (e, dragOver) => {
    if (dragOver !== isDragOver)
      setDragover(dragOver);
   
  };

  const getStyle = () => {
    var newStyle = {};

    newStyle["width"] = parseInt(props.style.width.value.slice(0,-2)) - 2 + "px" ;
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 2 + "px" ;
    newStyle["top"] = props.style.top.value;
    newStyle["left"] = props.style.left.value;
    newStyle["position"] = "absolute";
   
    return newStyle;
  };

  const getEditorStyle = () => {
    var newStyle = {};

    newStyle["width"] = parseInt(props.style.width.value.slice(0,-2)) - 2 + "px" ;
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 2 + "px" ;
    newStyle["top"] = props.style.top.value;
    newStyle["left"] = props.style.left.value;
    newStyle["position"] = "absolute";
    newStyle["border"] = props.errors ? props.errors.border : props.style.border.value;
    return newStyle;
  };

  return (
    <React.Fragment >
      <div
        onClick={props.onClick} 
        style={getContainerStyle()}
        id={props.data.id}/>
    
      <div 
        draggable={props.draggable}
        onDragStart={(e) => props.onDragStart(e)}
        onDrop={(e) => props.onlyLabel && onDropColumn(e)}
        onDragOver={(e) => props.onlyLabel && onDrag(e, true)}
        onDragLeave={(e) => props.onlyLabel && onDrag(e, false)}
        onClick={props.onClick} 
        style={getStyle()}>
        <RichTextEditor 
          style={getEditorStyle() }  
          //containerStyle={props.style }
          onlyLabel={props.onlyLabel}
          data = {{id:props.data.id}}
          hideToolBar={!props.data.properties.showToolBar.value}
          format = {props.data.properties.text.value == "" ? undefined : props.data.properties.text.value}
          onSaveEdition = {(data) => props.onChange(data)} 
        />
      </div>
      {props.errors && !props.errors.isColumn && <input readOnly style={props.errors.styles} value={props.errors.value} />}
   </React.Fragment>
  );
}
